import { BaseObservableForm } from "apps-module/app/shared-library/forms/base-observable.form";
import { FormControl, FormGroup } from "@angular/forms";
import { nameof } from "apps-module/app/shared-library/utils/common.utils";
import { FormSearchParametersModel } from "apps-module/app/entry-modules/charity-search/models/form-search-parameters.model";

export class SearchForm extends BaseObservableForm<FormSearchParametersModel> {
    public static createForm(initialSearchParams: FormSearchParametersModel): SearchForm {
        const formGroup = new FormGroup({
            homePageId: new FormControl<string>(initialSearchParams.homePageId),
            pageNumber: new FormControl<number>(initialSearchParams.pageNumber),
            sortOption: new FormControl<string>(initialSearchParams.sortOption),
            searchText: new FormControl<string>(initialSearchParams.searchText),
            aooa: new FormControl<Array<string>>(initialSearchParams.aooa),
            aoob: new FormControl<Array<string>>(initialSearchParams.aoob),
            aood: new FormControl<Array<string>>(initialSearchParams.aood),
            classification1: new FormControl<Array<string>>(initialSearchParams.classification1),
            classification2: new FormControl<Array<string>>(initialSearchParams.classification2),
            classification3: new FormControl<Array<string>>(initialSearchParams.classification3),
            income: new FormControl<Array<string>>(initialSearchParams.income),
            site: new FormControl<Array<string>>(initialSearchParams.site),
            include: new FormControl<Array<string>>(initialSearchParams.include),
            orgType: new FormControl<Array<string>>(initialSearchParams.orgType)
        });

        return new SearchForm(formGroup, initialSearchParams);
    }

    public get nativeForm(): FormGroup { return this.formInstance; }

    public get pageNumber(): FormControl<number> { return this.formInstance.get(nameof<FormSearchParametersModel>("pageNumber")) as FormControl<number>; }
    public get homePageId(): FormControl<string> { return this.formInstance.get(nameof<FormSearchParametersModel>("homePageId")) as FormControl<string>; }
    public get sortOption(): FormControl<string> { return this.formInstance.get(nameof<FormSearchParametersModel>("sortOption")) as FormControl<string>; }
    public get searchText(): FormControl<string> { return this.formInstance.get(nameof<FormSearchParametersModel>("searchText")) as FormControl<string>; }
    public get aooa(): FormControl<Array<string>> { return this.formInstance.get(nameof<FormSearchParametersModel>("aooa")) as FormControl<Array<string>>; }
    public get aoob(): FormControl<Array<string>> { return this.formInstance.get(nameof<FormSearchParametersModel>("aoob")) as FormControl<Array<string>>; }
    public get aood(): FormControl<Array<string>> { return this.formInstance.get(nameof<FormSearchParametersModel>("aood")) as FormControl<Array<string>>; }
    public get classification1(): FormControl<Array<string>> { return this.formInstance.get(nameof<FormSearchParametersModel>("classification1")) as FormControl<Array<string>>; }
    public get classification2(): FormControl<Array<string>> { return this.formInstance.get(nameof<FormSearchParametersModel>("classification2")) as FormControl<Array<string>>; }
    public get classification3(): FormControl<Array<string>> { return this.formInstance.get(nameof<FormSearchParametersModel>("classification3")) as FormControl<Array<string>>; }
    public get income(): FormControl<Array<string>> { return this.formInstance.get(nameof<FormSearchParametersModel>("income")) as FormControl<Array<string>>; }
    public get site(): FormControl<Array<string>> { return this.formInstance.get(nameof<FormSearchParametersModel>("site")) as FormControl<Array<string>>; }
    public get include(): FormControl<Array<string>> { return this.formInstance.get(nameof<FormSearchParametersModel>("include")) as FormControl<Array<string>>; }
    public get orgType(): FormControl<Array<string>> { return this.formInstance.get(nameof<FormSearchParametersModel>("orgType")) as FormControl<Array<string>>; }

    private constructor(
        formInstance: FormGroup,
        initialSearchParams: FormSearchParametersModel
    ) {
        super(formInstance, initialSearchParams);
    }

    public searchByPageNumber(): void {
        this.submit({
            searchText: this.initialFormState.searchText,
            aooa: this.initialFormState.aooa,
            aoob: this.initialFormState.aoob,
            aood: this.initialFormState.aood,
            classification1: this.initialFormState.classification1,
            classification2: this.initialFormState.classification2,
            classification3: this.initialFormState.classification3,
            income: this.initialFormState.income,
            site: this.initialFormState.site,
            include: this.initialFormState.include,
            orgType: this.initialFormState.orgType
        });
    }

    public searchByFilters(): void {
        this.submit({
            pageNumber: 1,
            searchText: this.initialFormState.searchText
        });
    }

    public searchByText(): void {
        this.submit({
            pageNumber: 1
        });
    }
}
